import { useEffect, useState } from "react"
import { readContract } from "wagmi/actions"
import { config } from "../lib/wagmi"
import { childPool } from "../utils/contract"
import { formatEther } from "viem"

export const useRootTotalBond = (contractAddress) => {
    const [bondSize, setBondSize] = useState(null)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)

    useEffect(() => {
        if (!contractAddress) return

        const fetchTotalBond = async () => {
            setLoading(true)
            setError(null)
            try {
                const result = await readContract(config, {
                    address: contractAddress,
                    abi: childPool.abi,
                    functionName: "totalBond",
                })
                setBondSize({
                    raw: result,
                    formatted: formatEther(result)
                })
            } catch (err) {
                setError(err)
                console.error("Error fetching bond size:", err)
            } finally {
                setLoading(false)
            }
        }

        fetchTotalBond()
    }, [contractAddress])

    return { bondSize, loading, error }
}